import { ManageElement } from "./ManageElement";
import { TagOwnerStore } from "stores/TagOwnerStore";

export class TagOwner extends ManageElement {
  static _store: TagOwnerStore;
}